import React, { useState } from 'react';
import { Scrollbars } from 'rc-scrollbars';

import { CheckBox, Chip, Button } from '../../../../components';
import {
  Container,
  Wrapper,
  Title,
  Content,
  BenchmarkItem,
  BenchmarkList,
  ReviewList,
  SelectAll,
  Footer,
} from './PortfolioAnalyticsStyles';

const Benchmarks = [
  {
    id: 1,
    label: 'Absolute Return Benchmark',
  },
  {
    id: 2,
    label: 'Buyout Benchmark',
  },
  {
    id: 3,
    label: 'Cash & Fixed Income Benchmark',
  },
  {
    id: 4,
    label: 'Absolute Return Benchmark',
  },
  {
    id: 5,
    label: 'Buyout Benchmark',
  },
  {
    id: 6,
    label: 'Cash & Fixed Income Benchmark',
  },
  {
    id: 7,
    label: 'Absolute Return Benchmark',
  },
  {
    id: 8,
    label: 'Buyout Benchmark',
  },
  {
    id: 9,
    label: 'Cash & Fixed Income Benchmark',
  },
  {
    id: 10,
    label: 'Cash & Fixed Income Benchmark',
  },
  {
    id: 11,
    label: 'Absolute Return Benchmark',
  },
  {
    id: 12,
    label: 'Buyout Benchmark',
  },
  {
    id: 13,
    label: 'Cash & Fixed Income Benchmark',
  },
];

type Props = {};

export const PortfolioAnalytics: React.FC<Props> = () => {
  const [benchmarks, setBenchmarks] = useState(Benchmarks);
  const [selectAll, setSelectAll] = useState(false);

  const handleOnAdd = (id: number) => () => {
    setBenchmarks(
      benchmarks.map((item: any) => {
        if (item.id === id) {
          item.selected = !!!item.selected;
        }

        return item;
      })
    );
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    setBenchmarks(
      benchmarks.map((item: any) => ({
        ...item,
        selected: !selectAll,
      }))
    );
  };

  return (
    <Container>
      <Wrapper>
        <Title>1. Select Benchmark</Title>
        <Content>
          <BenchmarkList>
            <SelectAll>
              <CheckBox onClick={handleSelectAll} checked={selectAll}>
                Select All
              </CheckBox>
            </SelectAll>
            <Scrollbars>
              {benchmarks.map((item: any) => (
                <BenchmarkItem>
                  <CheckBox
                    key={item.id}
                    onClick={handleOnAdd(item.id)}
                    checked={item.selected}
                  >
                    {item.label}
                  </CheckBox>
                </BenchmarkItem>
              ))}
            </Scrollbars>
          </BenchmarkList>
        </Content>
      </Wrapper>
      <Wrapper>
        <Title>2. Review Upload</Title>
        <Content>
          <ReviewList>
            {benchmarks.map((item: any) =>
              item.selected ? (
                <Chip
                  key={item.id}
                  label={item.label}
                  onDelete={handleOnAdd(item.id)}
                />
              ) : null
            )}
          </ReviewList>
        </Content>
      </Wrapper>
      <Footer>
        <Button variant={'secondary'}>Cancel</Button>
        <Button>Upload</Button>
      </Footer>
    </Container>
  );
};
